import { render, staticRenderFns } from "./NeedRecord.vue?vue&type=template&id=10fad36e&scoped=true&"
import script from "./NeedRecord.vue?vue&type=script&lang=js&"
export * from "./NeedRecord.vue?vue&type=script&lang=js&"
import style0 from "./NeedRecord.vue?vue&type=style&index=0&id=10fad36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fad36e",
  null
  
)

export default component.exports